
import SimHistory from "../Game/simhistory";
import SimSummary from "../Game/simSummary";
import PlayerBalance from "../Game/playerbalance";
import SimulationConfig from "../Game/simulationConfig";

export const publicRoutes = [
  { path: "/", components: PlayerBalance },  
  { path: "/player", components: PlayerBalance },  
  { path: "/history", components: SimHistory},
  { path: "/summary", components: SimSummary },
  { path: "/config", components: SimulationConfig }
];

export const privateRoutes = [];
//   { path: "/games", components: SlotGamesPage },
// ];
